// @flow
import {
  fetchNotifications as apiFetchNotifications,
  dismissNotifications as apiDismissNotifications
} from 'api/userNotifications';
import type { Notifications } from 'api/userNotifications';
import { sortNotifications } from 'utils/userNotifications';
import type { Dispatch, GetState } from '..';

type FetchNotificationsRequestAction = {
  type: 'NOTIFICATIONS_FETCH_REQUEST'
};
type FetchNotificationsSuccessAction = {
  type: 'NOTIFICATIONS_FETCH_SUCCESS',
  notifications: Notifications
};

export type Action =
  | FetchNotificationsRequestAction
  | FetchNotificationsSuccessAction;

const fetchNotificationsRequest = (): FetchNotificationsRequestAction => ({
  type: 'NOTIFICATIONS_FETCH_REQUEST'
});

const fetchNotificationsSuccess = (
  notifications: Notifications
): FetchNotificationsSuccessAction => ({
  type: 'NOTIFICATIONS_FETCH_SUCCESS',
  notifications
});

export const fetchNotifications = () => (
  dispatch: Dispatch,
  getState: GetState
) => {
  const notifications = getState().userNotifications;

  if (notifications && notifications.isFetching) {
    return (Promise.resolve(): Promise<void>);
  }

  dispatch(fetchNotificationsRequest());
  return apiFetchNotifications().then(fetchedNotifications => {
    const sortedNotifications = sortNotifications(fetchedNotifications);
    dispatch(fetchNotificationsSuccess(sortedNotifications));
  });
};

export const dismissNotifications = (ids: Array<string>) => (
  dispatch: Dispatch
) => {
  dispatch(fetchNotificationsRequest());

  return apiDismissNotifications(ids).then(fetchedNotifications => {
    const sortedNotifications = sortNotifications(fetchedNotifications);
    dispatch(fetchNotificationsSuccess(sortedNotifications));
  });
};
